export function backButton(elem) {
    const backButtons = elem;
    backButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = '/'; // Fallback if no history
            }
        })
    })
}